import React, { VFC, ReactNode } from 'react'
import { QuestionRoutes } from 'types'
import useAnalysis from 'hooks/useAnalysis'

import Page from './Page'
import YesButton from './YesButton'
import NoButton from './NoButton'
import Pagination from './Pagination'
import Share from './Share'

type Props = {
  q: ReactNode
  routes: QuestionRoutes
}

const Question: VFC<Props> = (props) => {
  const { questionNumber } = useAnalysis()

  return (
    <Page>
      <div className="rounded-full tracking-[0.05em] font-bold font-shippori-mincho text-lg bg-custom-4 w-[59px] h-[59px] text-center text-white leading-[59px] mx-auto mt-10 sm:w-[118px] sm:h-[118px] sm:leading-[99px] sm:text-4xl sm:mt-20 lg:w-16 lg:h-16 lg:leading-[64px] lg:text-xl lg:mt-8">
        Q.{questionNumber}
      </div>

      <p className="text-center text-[15px] leading-[22.5px] mt-7 sm:text-[30px] sm:leading-[45px] sm:mt-14 lg:text-xl lg:mt-9">
        {props.q}
      </p>

      <div className="flex flex-wrap max-w-[245px] space-y-5 mx-auto mt-10 sm:mt-20 sm:max-w-[490px] sm:space-y-10 lg:max-w-[540px] lg:space-y-0 lg:mt-[52px] lg:justify-between">
        <YesButton
          index={props.routes.yes.index}
          done={props.routes.yes.done || false}
        />
        <NoButton
          index={props.routes.no.index}
          done={props.routes.no.done || false}
        />
      </div>

      <Pagination className="mt-10 sm:mt-20 lg:mt-[62px]" />

      <Share className="mt-10 sm:mt-[84px] lg:mt-[52px]" tight />
    </Page>
  )
}

export default Question
